import React from "react";

/**
 * @component FolderMoveIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <FolderMoveIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const FolderMoveIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="FolderMoveIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M10 4l2 2h8a2 2 0 011.995 1.851L22 8v10c0 1.06-.81 1.919-1.85 1.995L20 20H4a2 2 0 01-1.994-1.85L2 18V6a2 2 0 011.851-1.995L4 4h6zm10 4H4v10h16V8zm-10 2l4 3-4 3v-2H6v-2h4v-2z"
        fillRule="evenodd"
      />
    </svg>
  )
);
FolderMoveIcon.displayName = "FolderMoveIcon";
export default FolderMoveIcon;
